





























import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import SmallText from "@/common/components/atoms/SmallText.vue";
import IconBalloons from "@/common/components/icons/IconBalloons.vue";

import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import { Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import sitemap from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    SmallText,
    IconBalloons,
    TheTemplateJ
  }
})
export default class ThanksPointNoGifts extends Vue {
  breadcrumb: any = [
    {
      text: "",
      url: sitemap.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: "",
      pageType: "lower"
    }
  ];

  get thanksPointName1() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksPointName2() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName2 + "メッセージ";
    await commons.setbreadcrumb(this.breadcrumb);
  }

  mounted() {
    AuthStorage.checkLogin();
  }
}
